const ns = {}

ns.debug = function (key, msg) {
  console.log(key, msg)
}

ns.error = function (key, err) {
  console.log(key, err)
}

export default ns
